// extracted by mini-css-extract-plugin
export var bubble = "_2b-0";
export var container = "_2b-f";
export var contrastBorder = "_2b-g";
export var greyOut = "_2b-2";
export var initialsColor0 = "_2b-3";
export var initialsColor1 = "_2b-4";
export var initialsColor10 = "_2b-d";
export var initialsColor11 = "_2b-e";
export var initialsColor2 = "_2b-5";
export var initialsColor3 = "_2b-6";
export var initialsColor4 = "_2b-7";
export var initialsColor5 = "_2b-8";
export var initialsColor6 = "_2b-9";
export var initialsColor7 = "_2b-a";
export var initialsColor8 = "_2b-b";
export var initialsColor9 = "_2b-c";
export var initialsWrapper = "_2b-1";
export var large = "_2b-l";
export var medium = "_2b-k";
export var mediumSmall = "_2b-j";
export var mediumSmallMedium = "_2b-o";
export var micro = "_2b-h";
export var small = "_2b-i";
export var tiny = "_2b-n";
export var xTiny = "_2b-m";